import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { signupFromValidatorOrderCreate } from '../../services/validatior/formValidator/authValidator';
import { signUp } from '../../redux/reducers/authSlice';
import { toast } from 'react-toastify';
import { getPostalSectors } from '../../redux/reducers/postalSectorsSlice';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import DropdownInput from '../../components/common/DropdownInput';
import GoogleAutoCompleteComp from '../../components/common/GoogleAutoComplete/GoogleAutoCompleteComp';
import { setSelectAddress } from '../../redux/reducers/createOrderSlice';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';

const SignupComp = ({ createOrder }) => {
    const [sortedLocations, setSortedLocations] = useState([])
    const { user } = useSelector((state) => state.auth)
    const { postalData
    } = useSelector((state) => state.poastalSectorsLists);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isPwdShown, setIsPwdShown] = useState(true);
    const { selectedAddress } = useSelector((state) => state.createOrderSlice)

    const [locations, setLocations] = useState(selectedAddress ?? {
        address: '',
        country: '',
        postalCode: '',
        isPrimary: true,
        isActive: true,
        location: {
            type: "Point",
            coordinates: [""]
        }
    })

    const signUpFormik = useFormik({
        initialValues: signupFromValidatorOrderCreate(user, selectedAddress, 'initialValues'),
        validationSchema: signupFromValidatorOrderCreate(user, selectedAddress, 'validationSchema'),
        onSubmit: (data) => {
            if (data.country === "SG") {
                data.country = "Singapore"
            }
            dispatch(setSelectAddress(
                {
                    selectedAddress: {
                        ...selectedAddress,
                        address: data.address,
                        postalCode: data.postalCode,
                        country: data.country,
                        unitNo: data.unitNo,
                        isFromInput: false,
                        title: "Home",
                        generalLocation: data?.generalLocation
                    }
                }
            ))


            let fullName = `${data.fname}` + " " + `${data.lname}`;
            let bodyData = {
                ...data, locations: [{ ...locations, title: "Home", unitNo: data?.unitNo, address: data.address }], name: fullName
            }
            delete bodyData.generalLocation
            // delete bodyData.addressName
            delete bodyData.unitNo
            delete bodyData.confirmEmail
            delete bodyData.postalCode
            delete bodyData.country
            delete bodyData.address


            dispatch(signUp({
                apiData: bodyData,
                navigate: navigate,
                signUpFormik: signUpFormik,
                dispatch: dispatch,
                creatingOrder: true
            }))



        }
    })
    const handleAddress = (addressObj, address) => {
        if (addressObj?.postal_code) {
            setLocations({
                ...locations,
                address: address?.label,
                country: addressObj?.country,
                postalCode: addressObj?.postal_code,
                isPrimary: true,
                isActive: true,
                location: {
                    type: "Point",
                    coordinates: [Number(addressObj?.lng), Number(addressObj?.lat)]
                }
            })
            signUpFormik.setFieldValue("country", addressObj?.country)
            signUpFormik.setFieldValue("postalCode", addressObj?.postal_code)

            setSortedLocations(postalData.filter(item => item?.postalCode == addressObj?.postal_code.slice(0, 2)))
        }
        else if (!addressObj?.postal_code && address?.label) {
            toast.error('Try to search more precisely')
        }
    }

    const handleInputChangeForPhone = (e) => {
        e.target.value = e.target.value.replace(/\D/g, ''); // Filter out non-digit characters
        signUpFormik.handleChange(e); // Call Formik's handleChange with the modified event
    };
    useEffect(() => {
        dispatch(getPostalSectors())
    }, [])
    useEffect(() => {
        setSortedLocations(postalData.filter(item => item?.postalCode == selectedAddress?.postalCode.slice(0, 2)))


    }, [postalData])
    useEffect(() => {
        signUpFormik.setFieldValue("generalLocation", sortedLocations[0]?.generalLocation)

    }, [sortedLocations])

    return (
        <>
            <div className="auth-signup ch-f">
                <form onSubmit={signUpFormik.handleSubmit}>
                    <div className="acc-info mb-4">
                        <p>Account Information</p>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="">First Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="fname"
                                        name="fname"
                                        placeholder="Your First Name"
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.fname}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.fname &&
                                        signUpFormik.errors.fname}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="">Last Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lname"
                                        name="lname"
                                        placeholder="Your Last Name"
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.lname}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.lname &&
                                        signUpFormik.errors.lname}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        {" "}
                                        Email Address *{" "}
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        id="email"
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.email}
                                        placeholder="Enter your email"
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.email &&
                                        signUpFormik.errors.email}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        {" "}
                                        Confirm Email Address *{" "}
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="confirmEmail"
                                        id="confirmEmail"
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.confirmEmail}
                                        placeholder="Enter your email"
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.confirmEmail &&
                                        signUpFormik.errors.confirmEmail}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group international-location-w">
                                    <label htmlFor="email" className="form-label">
                                        Mobile Number *
                                    </label>
                                    <div className="international-location">
                                        <select
                                            aria-label="Default select example"
                                            className="form-select"
                                            name="countryCode"
                                            id="countryCode"

                                            onChange={signUpFormik.handleChange}
                                            value={signUpFormik.values.countryCode}
                                        >
                                            <option value="65">+65</option>

                                        </select>
                                        <p className='form-error-message'>{signUpFormik.touched.countryCode &&
                                            signUpFormik.errors.countryCode}</p>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="phone"
                                        name="phoneNumber"
                                        maxLength={25}
                                        onChange={handleInputChangeForPhone}
                                        value={signUpFormik.values.phoneNumber}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.phoneNumber &&
                                        signUpFormik.errors.phoneNumber}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">

                                    <div className="mb-3 form-password-toggle">
                                        <div className="position-relative">
                                            <label className="form-label" htmlFor="password">
                                                Password *
                                            </label>
                                            <div className="input-group input-group-merge ">
                                                <input
                                                    type={isPwdShown ? "password" : "text"}
                                                    id="password"
                                                    className="form-control"
                                                    name='password'
                                                    value={signUpFormik?.values.password}
                                                    onChange={signUpFormik.handleChange}
                                                    placeholder=""
                                                    aria-describedby="password"
                                                />

                                                <span className="input-group-text cursor-pointer">
                                                    <FontAwesomeIcon
                                                        icon={
                                                            isPwdShown ?
                                                                icon({ name: "eye-slash" })
                                                                : icon({ name: "eye" })
                                                        }
                                                        onClick={() => setIsPwdShown(!isPwdShown)}
                                                    />
                                                </span>

                                            </div>

                                        </div>
                                        <p className='form-error-message'>{signUpFormik.touched.password &&
                                            signUpFormik.errors.password}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Date of birth</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            sx={{ width: '100%' }}
                                            format='DD/MM/YYYY'
                                            onChange={(newValue) =>
                                                signUpFormik.setFieldValue('dob', new Date(newValue).toISOString())
                                            }
                                            value={dayjs(signUpFormik.values.dob)}
                                            renderInput={(params) => (
                                                <TextField {...params} className={`!p-0`} />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <p className='form-error-message'>{signUpFormik.touched.dob &&
                                        signUpFormik.errors.dob}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">

                                    <DropdownInput
                                        label={"Your Property Type"}
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.property_type}
                                        name="property_type"
                                        id="property_type"
                                        options={[
                                            { value: "HDB", option: "HDB" },
                                            { value: "Condo", option: "Condo" },
                                            { value: "Landed", option: "Landed" },
                                        ]}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.property_type &&
                                        signUpFormik.errors.property_type}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="acc-info">
                        <p>Your Address</p>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">

                                    <label htmlFor="email" className="form-label">
                                        Address Line 1 *
                                    </label>
                                    {/* <GoogleAutoCompleteComp handleAddressData={handleAddress} editData={selectedAddress ? selectedAddress : null} disabledAdd={true} /> */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="address"
                                        name="address"
                                        placeholder="Block / Street name"
                                        onChange={signUpFormik.handleChange}
                                        disabled={user}
                                        value={signUpFormik.values.address}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.address &&
                                        signUpFormik.errors.address}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Address Line 2
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="unitNo"
                                        name="unitNo"
                                        placeholder="Floor/unit number/Building name"
                                        onChange={signUpFormik.handleChange}
                                        disabled={user}
                                        value={signUpFormik.values.unitNo}
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Postal Code
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        id="postalCode"
                                        name="postalCode"

                                        value={locations?.postalCode}
                                        placeholder="Enter Postal Code"
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.postalCode &&
                                        signUpFormik.errors.postalCode}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Country
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        id="country"
                                        name="country"
                                        placeholder="Enter Country"
                                        value={locations?.country ? "Singapore" : ""}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.country &&
                                        signUpFormik.errors.country}</p>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Name of address
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="addressName"
                                        name="addressName"
                                        disabled={user}
                                        placeholder="Enter Address"
                                        onChange={signUpFormik.handleChange}
                                        value={signUpFormik.values.addressName}
                                    />
                                    <p className='form-error-message'>{signUpFormik.touched.addressName &&
                                        signUpFormik.errors.addressName}</p>
                                </div>
                            </div> */}

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Location
                                    </label>

                                    <select
                                        aria-label="Default select example"
                                        className="form-select"
                                        name="generalLocation"
                                        id="generalLocation"

                                        onChange={(e) => {
                                            setLocations({
                                                ...locations,
                                                generalLocation: e.target.value,
                                            });
                                            signUpFormik.setFieldValue("generalLocation", e.target.value);

                                        }}
                                    >
                                        {sortedLocations.map((item) => {
                                            return (
                                                <option value={item?.generalLocation}>
                                                    {item?.generalLocation}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!user && <div className="acc-info">
                        <p>Notification</p>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="terms-conditions"
                                name="terms"
                                onChange={(e) => signUpFormik.setFieldValue('isNotify', e.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="terms-conditions"
                            >
                                Keep Me Update with news, special promotions via email or sms
                            </label>
                        </div>
                    </div>}
                    <div className="sign-bottom">
                        <div className="text-text">By signing up, you agree to and verify you have read our <a href="https://www.oneheartcleaning.com.sg/terms" target="blank" style={{ cursor: "pointer" }} className="colour-red">Terms and Conditions</a> and <a href="https://www.oneheartcleaning.com.sg/privacy" target="blank" style={{ cursor: "pointer" }} className="colour-red">Privacy Policy</a>.</div>
                        <div className="sign-up-btn d-block d-lg-flex align-items-center justify-content-between text-center mb-4">
                            <div className="pay-wrap">
                                <img src="/assets/images/pay.png" alt="" />
                            </div>
                            <button type={"submit"} className="btn rounded-pill">{!user ? "Proceed" : "Pay"}</button>
                        </div>

                    </div>
                </form>
            </div>
        </>
    )
}

export default SignupComp